/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-11 17:37:18
 * @Explain: 周期活动
 */
import http from '../http';
import httpV2 from '../http-v2';

const MODEL = '/campaign_experiment';

export default {
  // 获取列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取当前活动 - 国家列表
  getCountryData(data: Record<any, any>) {
    return http.post(`${MODEL}/task_country_data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add_campaign`, data, {
      params: {
        switchReqToUnderline: true, // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update_campaign`, data, {
      params: {
        switchReqToUnderline: true, // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 创建草稿
  onAddDraft(data: Record<any, any>) {
    return http.post(`${MODEL}/add_draft`, data, {
      params: {
        switchReqToUnderline: true, // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 编辑草稿
  onEditDraft(data: Record<any, any>) {
    return http.post(`${MODEL}/update_draft`, data, {
      params: {
        switchReqToUnderline: true, // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 更新活动类型
  updateActivityType(data: Record<any, any>) {
    return http.post(`${MODEL}/update_campaign_type`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 验证标题是否重复
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/get_campaign`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略 req attributes_default_value 对象 大小写转化
        ignoreConvertedKey: JSON.stringify(['attributes_default_value']),
        // 忽略 rep attributes_default_value 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 获取上次提交活动的详情
  getLastDetails() {
    return http.post(
      `${MODEL}/get_latest_campaign`,
      {},
      {
        params: { switchReqToUnderline: true },
      },
    );
  },
  // 获取审批人列表
  getApproverList(data: Record<any, any>) {
    return http.post(`${MODEL}/list_check_user`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 审批
  onApproval(data: Record<any, any>) {
    return http.post(`${MODEL}/approve_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 审批 - 催办
  onApprovalUrge(data: Record<any, any>) {
    return http.post(`${MODEL}/reminder_check_user`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 撤销
  onRevoke(data: Record<any, any>) {
    return http.post(`${MODEL}/cancel_check`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 开始活动
  onStart(data: Record<any, any>) {
    return http.post(`${MODEL}/resume_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 暂停活动
  onSuspend(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 终止活动
  onTermination(data: Record<any, any>) {
    return http.post(`${MODEL}/stop_campaign`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 发送测试邮件
  onSendTestMail(data: Record<any, any>) {
    return http.post(`${MODEL}/test_campaign`, data, {
      params: {
        switchReqToUnderline: true,
        // 忽略  req variablePair  variable_pair 对象 大小写转化
        ignoreConvertedValueKey: JSON.stringify([
          'variable_pair',
          'variablePair',
          'attributes_default_value',
          'attributesDefaultValue',
        ]),
      },
    });
  },
  // 撤销 - 已计划列表操作项
  onRevokeScheduled(data: Record<any, any>) {
    return http.post(`${MODEL}/revoke`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查询活动状态统计聚合接口(可用于判断哪个状态下有数据)
  getStateStats(data: Record<any, any>) {
    return http.post(`${MODEL}/get_state_stats`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 查询联系人自定义字段是否被删除
  checkAttribute(data: Record<any, any>) {
    return httpV2.post(`${MODEL}/check_attribute`, data, {
      params: {
        switchReqToUnderline: true,
        ignoreConvertedKey: JSON.stringify(['attributes']),
        ignoreConvertedValueKey: JSON.stringify(['attributes']),
      },
    });
  },
};
